import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, of, tap } from 'rxjs'
import { RequestCacheService } from '../services/request-cache.service'

@Injectable()
export class CachingInterceptor implements HttpInterceptor {
    constructor(private requestCacheService: RequestCacheService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.isCacheable(req)) {
            return next.handle(req)
        }

        const cachedResponse = this.requestCacheService.get(req)
        return cachedResponse ? of(cachedResponse) : this.sendRequest(req, next, this.requestCacheService)
    }

    private isCacheable(req: HttpRequest<any>): boolean {
        return !!req.headers.get('cache-request') || false
    }

    private sendRequest(
        req: HttpRequest<any>,
        next: HttpHandler,
        cache: RequestCacheService
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap((event) => {
                if (event instanceof HttpResponse) {
                    cache.put(req, event)
                }
            })
        )
    }
}
